export const BESTSELLING_TITLE = 'Bestselling posters';
export const TRENDING_TITLE = 'Trending posters';
export const BRANDS_TITLE = 'More from this brandshop';

export const BESTSELLING = 'bestselling';
export const TRENDING = 'trending';
export const BRANDS = 'brands';

export const BESTSELLING_POSTERS_ROUTE = '/posters/all';
export const BROWSE_BRANDS_ROUTE = '/browse-brands';

export const noImageUrl = '/images/no-image.svg';

export const LUMINO_MOUNTING_VIDEO = '814903979';
export const LUMINO_EXTERNAL_ID_FALLBACK = 6355779;

export const LUMINO_ANIMATION_VIDEO_INDEX = 1;
export const LUMINO_DETAILS_VIDEO_INDEX = 0;
export const LUMINO_MOUNTING_VIDEO_INDEX = 6;

export const LUMINO_DETAILS_VIDEO_FALLBACK = '820920537';
export const LUMINO_ANIMATION_VIDEO_FALLBACK = '820921932';

export const LUMINO_VIDEO_TIME_TO_PAUSE = 2 * 60 * 1000;
